import $ from 'jquery';
import JQueryView, { on } from '../../../../common/views/jqueryView';

export default class PreView extends JQueryView {
  selectedKycTypeId: string;

  constructor() {
    super('.show');
    this.selectedKycTypeId = '';
    this.render();
  }

  @on({ event: 'change', selector: '.kyc-type' })
  onChangeKycType(event: JQuery.ChangeEvent) {
    this.selectedKycTypeId = event.target.id;
    this.render();
  }

  render() {
    $('.submission').removeClass('selected');
    if (this.selectedKycTypeId === '') {
      $('#kyc_type_submit').prop('disabled', true);
    } else {
      $(`label[for="${this.selectedKycTypeId}"]`).addClass('selected');
      $('#kyc_type_submit').prop('disabled', false);
    }
  }
}
